module.exports = __webpack_public_path__ + "assets/logo.svg.79d22ed8.png";